import React from 'react';
import { TQuestion, QuestionLibraryState } from '../types';
import { TableCell } from '@mui/material';
import { classes } from '../../Components/GenericTable/styles';
import moment from 'moment-timezone';
import { getKeyByValue } from './Modals/NewQuestion';
import { fieldTypeValues } from '../config';

const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const QuestionsTableRow = ({
  column,
  item,
  tableHovered
}: {
  column: QuestionLibraryState['questionsTableState']['columns'][number];
  item: TQuestion;
  tableHovered: boolean;
}) => {
  if (!column.enabled) return null;
  switch (column.id) {
    case 'name':
      return (
        <TableCell
          key={item.id + column.id}
          sx={{
            ...classes.sticky,
            ...classes.idTableCell,
            minWidth: '150px',
            left: '0px'
          }}
        >
          {item.library_field_name}
        </TableCell>
      );
    case 'type':
      return (
        <TableCell
          key={item.id + column.id}
          sx={{
            ...classes.sticky,
            ...classes.itemTitleTableCell,
            ...(tableHovered && classes.scrollShadowVisible),
            left: '150px',
            minWidth: '100px'
          }}
        >
          {getKeyByValue(fieldTypeValues, item.field_type)}
        </TableCell>
      );
    case 'created_by':
      return <TableCell key={item.id + column.id}>{item.created_by}</TableCell>;
    case 'updated_by':
      return <TableCell key={item.id + column.id}>{item.updated_by || '-'}</TableCell>;
    case 'created_at':
      return (
        <TableCell key={item.id + column.id}>
          {item.created_at
            ? moment.tz(item.created_at, browserTimezone).format('D MMM YYYY, hh:mma z')
            : '-'}
        </TableCell>
      );
    case 'updated_at':
      return (
        <TableCell key={item.id + column.id}>
          {item.updated_at
            ? moment.tz(item.updated_at, browserTimezone).format('D MMM YYYY, hh:mma z')
            : '-'}
        </TableCell>
      );
    default:
      return <TableCell></TableCell>;
  }
};

export default QuestionsTableRow;
